import React from "react";

export default function PlannerSkeleton() {
  return (
    <div className="planner-skeleton">
      Loading planner data...
    </div>
  );
}
